import { SHORTCUT_DELIVERY_ZONE_FIELDS, SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import { DeliveryZone } from '@@partner:types:app'
import { CommonPager, CommonSort, NestedFilter, PageInfo } from '@@partner:types:graphql'
import { gql, useLazyQuery, useQuery } from '@apollo/client'

export interface AllDeliveryZonesQuery {
  allDeliveryZones: {
    edges: DeliveryZone[]
    pageInfo: PageInfo
  }
}

export interface AllDeliveryZonesVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}



export const GQL_QUERY_DELIVERY_ZONES = gql`
  query allDeliveryZones(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allDeliveryZones(
      filter: $filter
      sort: $sort
      pager: $pager 
    ) {
      edges {
        ${SHORTCUT_DELIVERY_ZONE_FIELDS}
        shop {
          id
          name
          address
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }

`

export const useFetchAllDeliveryZones = (variables?: AllDeliveryZonesVariables) => 
  useQuery<AllDeliveryZonesQuery, AllDeliveryZonesVariables>(GQL_QUERY_DELIVERY_ZONES, {
    variables,
    fetchPolicy: 'network-only'
  })

export const useLazyFetchDeliveryZones = (variables?: AllDeliveryZonesVariables) =>
  useLazyQuery<AllDeliveryZonesQuery, AllDeliveryZonesVariables>(GQL_QUERY_DELIVERY_ZONES, {
    variables,
    fetchPolicy: 'network-only'
  })